import { useEffect, useState } from "react";
import { FolderOpen, Info, Search, Sparkles } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import AssetsTab from "./AssetsTab";
import StockTab from "./StockTab";
import AiImageTab from "./AiImageTab";
import ImageDetailsTab from "./ImageDetailsTab";

const TABS = [["assets", "Le tue immagini", FolderOpen], ["stock", "Foto stock", Search], ["ai", "Genera con AI", Sparkles]];

export default function ImagePickerDialog({ open, onOpenChange, api, projectId, assets, setAssets, initialQuery = "", onPick, title = "Sostituisci immagine", usedUrls = [], currentUrl = null, noStock = false }) {
  const [tab, setTab] = useState("stock");
  useEffect(() => { if (open) setTab(currentUrl ? "details" : noStock ? "assets" : "stock"); }, [open, currentUrl, noStock]);
  const base = noStock ? TABS.filter(([k]) => k !== "stock") : TABS;  // AI-image site: no stock photos
  const tabs = currentUrl ? [["details", "Dettagli e rigenera", Info], ...base] : base;
  const pick = (url, meta) => { onPick(url, meta); onOpenChange(false); };
  const props = { api, projectId, onPick: pick, setAssets };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl max-h-[88vh] overflow-y-auto" data-testid="image-picker-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{noStock ? "Sito con immagini AI: scegli tra le foto del cliente e le immagini del progetto, oppure rigenera con l'AI (solo dopo aver confermato il costo)." : "Scegli tra le tue immagini, le foto stock gratuite o genera una foto con l'AI (solo dopo aver confermato il costo)."}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-x-1 border-b">
          {tabs.map(([k, l, Icon]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`image-picker-tab-${k}`}
              className={`inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium border-b-2 -mb-px transition-colors ${tab === k ? "border-sky-600 text-sky-700" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
              <Icon size={13} />{l}
            </button>
          ))}
        </div>
        <div className="pt-1">
          {tab === "details" && currentUrl && <ImageDetailsTab api={api} projectId={projectId} url={currentUrl} onPick={pick} />}
          {tab === "assets" && <AssetsTab {...props} assets={assets} />}
          {tab === "stock" && <StockTab {...props} initialQuery={initialQuery} usedUrls={usedUrls} />}
          {tab === "ai" && <AiImageTab {...props} initialPrompt={initialQuery} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
